import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./components/LandingPage";
import { AdminPage } from "./components/AdminPage";
import { PublicWaitlistPage } from "./components/PublicWaitlistPage";
import { MyStatusPage } from "./components/MyStatusPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/waitlist" element={<PublicWaitlistPage />} />
          <Route path="/my-status/:id" element={<MyStatusPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
